import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { colors, fonts, spacing, borderRadius, shadows } from '../../constants';
import CreateUserForm from './CreateUserForm';

/**
 * CreateUserDialog Component
 * Dialog wrapper for create user form
 */
const CreateUserDialog = ({
  open,
  onClose,
  onCreate,
  creating,
  formData,
  errors,
  whatsappError,
  projects,
  loadingProjects,
  availableRegions,
  roles,
  onInputChange,
  onWhatsAppChange,
  onWhatsAppKeyPress,
  onRoleChange,
  onProjectsChange,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: borderRadius.modal,
          boxShadow: shadows.xl,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: `1px solid ${colors.borderDefault}`,
          pb: spacing.sm,
          pt: spacing.sm,
          background: colors.primaryGradient,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: fonts.weightBold, fontSize: '16px', color: colors.textWhite }}>
          Create New User
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            color: colors.textWhite,
            '&:hover': {
              backgroundColor: colors.primaryTint,
              color: colors.textWhite,
            },
          }}
        >
          <CloseIcon sx={{ fontSize: '20px' }} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: spacing.sm, px: spacing.md, pb: spacing.md }}>
        <CreateUserForm
          formData={formData}
          errors={errors}
          whatsappError={whatsappError}
          projects={projects}
          loadingProjects={loadingProjects}
          availableRegions={availableRegions}
          roles={roles}
          onInputChange={onInputChange}
          onWhatsAppChange={onWhatsAppChange}
          onWhatsAppKeyPress={onWhatsAppKeyPress}
          onRoleChange={onRoleChange}
          onProjectsChange={onProjectsChange}
        />
      </DialogContent>

      <DialogActions sx={{ px: spacing.md, py: '10px', borderTop: `1px solid ${colors.borderDefault}`, gap: '8px' }}>
        <Button
          onClick={onClose}
          sx={{
            textTransform: 'none',
            color: colors.textSecondary,
            fontSize: '13px',
            fontWeight: fonts.weightMedium,
            px: spacing.sm,
            py: '6px',
            '&:hover': {
              backgroundColor: colors.backgroundSoft,
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onCreate}
          variant="contained"
          disabled={creating}
          sx={{
            textTransform: 'none',
            background: colors.buttonPrimary,
            color: colors.textWhite,
            fontSize: '12px',
            fontWeight: fonts.weightSemiBold,
            px: spacing.md,
            py: '6px',
            minWidth: '110px',
            boxShadow: `0 4px 12px ${colors.primaryShadow}`,
            '&:hover': {
              background: colors.buttonPrimaryHover,
              boxShadow: `0 6px 16px ${colors.primaryShadowHover}`,
            },
            '&:disabled': {
              backgroundColor: colors.textDisabled,
              color: colors.textSecondary,
            },
          }}
        >
          {creating ? <CircularProgress size={18} color="inherit" /> : 'Create User'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateUserDialog;
